var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgDrugsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4987 16.0794V24.4649C26.4987 25.5247 25.6292 26.3843 24.5571 26.3843H11.6093C10.5021 26.3843 9.60449 25.4969 9.60449 24.4023V15.9497C9.60449 14.5958 10.7152 13.4978 12.0854 13.4978H23.8873C25.3294 13.4978 26.4987 14.6537 26.4987 16.0794Z",
    fill: "#D7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0855 14.0362C11.0068 14.0362 10.1431 14.899 10.1431 15.9496V24.4022C10.1431 25.1936 10.7938 25.8457 11.6095 25.8457H24.5572C25.3378 25.8457 25.9604 25.2214 25.9604 24.4647V16.0793C25.9604 14.9568 25.038 14.0362 23.8874 14.0362H12.0855ZM9.06616 15.9496C9.06616 14.2924 10.4239 12.9592 12.0855 12.9592H23.8874C25.6211 12.9592 27.0373 14.3504 27.0373 16.0793V24.4647C27.0373 25.8278 25.9209 26.9226 24.5572 26.9226H11.6095C10.2107 26.9226 9.06616 25.8 9.06616 24.4022V15.9496Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9027 18.6661C13.4027 18.6661 12.9934 18.2615 12.9934 17.7672V15.8571C12.9934 15.3628 13.4027 14.9587 13.9027 14.9587C14.4028 14.9587 14.8121 15.3628 14.8121 15.8571V17.7672C14.8121 18.2615 14.4028 18.6661 13.9027 18.6661Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9027 15.1512C13.5066 15.1512 13.1856 15.4714 13.1856 15.8573V17.7674C13.1856 18.1534 13.5067 18.474 13.9027 18.474C14.2986 18.474 14.6197 18.1534 14.6197 17.7674V15.8573C14.6197 15.4714 14.2987 15.1512 13.9027 15.1512ZM12.801 15.8573C12.801 15.2545 13.2987 14.7666 13.9027 14.7666C14.5067 14.7666 15.0043 15.2545 15.0043 15.8573V17.7674C15.0043 18.37 14.5068 18.8586 13.9027 18.8586C13.2985 18.8586 12.801 18.37 12.801 17.7674V15.8573Z",
    fill: "#0E2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1354 18.6661C17.6354 18.6661 17.2261 18.2615 17.2261 17.7672V15.8571C17.2261 15.3628 17.6354 14.9587 18.1354 14.9587C18.6354 14.9587 19.0447 15.3628 19.0447 15.8571V17.7672C19.0447 18.2615 18.6354 18.6661 18.1354 18.6661Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1353 15.1512C17.7392 15.1512 17.4183 15.4714 17.4183 15.8573V17.7674C17.4183 18.1534 17.7394 18.474 18.1353 18.474C18.5312 18.474 18.8523 18.1534 18.8523 17.7674V15.8573C18.8523 15.4714 18.5314 15.1512 18.1353 15.1512ZM17.0337 15.8573C17.0337 15.2545 17.5313 14.7666 18.1353 14.7666C18.7393 14.7666 19.237 15.2545 19.237 15.8573V17.7674C19.237 18.37 18.7395 18.8586 18.1353 18.8586C17.5312 18.8586 17.0337 18.37 17.0337 17.7674V15.8573Z",
    fill: "#0E2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3666 18.6661C21.8666 18.6661 21.4573 18.2615 21.4573 17.7672V15.8571C21.4573 15.3628 21.8666 14.9587 22.3666 14.9587C22.8666 14.9587 23.2759 15.3628 23.2759 15.8571V17.7672C23.2759 18.2615 22.8666 18.6661 22.3666 18.6661Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3665 15.1512C21.9704 15.1512 21.6495 15.4714 21.6495 15.8573V17.7674C21.6495 18.1534 21.9706 18.474 22.3665 18.474C22.7624 18.474 23.0835 18.1534 23.0835 17.7674V15.8573C23.0835 15.4714 22.7626 15.1512 22.3665 15.1512ZM21.2649 15.8573C21.2649 15.2545 21.7625 14.7666 22.3665 14.7666C22.9705 14.7666 23.4682 15.2545 23.4682 15.8573V17.7674C23.4682 18.37 22.9707 18.8586 22.3665 18.8586C21.7624 18.8586 21.2649 18.37 21.2649 17.7674V15.8573Z",
    fill: "#0E2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9027 24.7408C13.4027 24.7408 12.9934 24.3362 12.9934 23.8419V21.9324C12.9934 21.438 13.4027 21.0334 13.9027 21.0334C14.4028 21.0334 14.8121 21.438 14.8121 21.9324V23.8419C14.8121 24.3362 14.4028 24.7408 13.9027 24.7408Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9027 21.2257C13.5067 21.2257 13.1856 21.5463 13.1856 21.9323V23.8418C13.1856 24.2279 13.5067 24.5485 13.9027 24.5485C14.2986 24.5485 14.6197 24.2279 14.6197 23.8418V21.9323C14.6197 21.5463 14.2986 21.2257 13.9027 21.2257ZM12.801 21.9323C12.801 21.3297 13.2985 20.8411 13.9027 20.8411C14.5068 20.8411 15.0043 21.3297 15.0043 21.9323V23.8418C15.0043 24.4445 14.5068 24.9331 13.9027 24.9331C13.2985 24.9331 12.801 24.4445 12.801 23.8418V21.9323Z",
    fill: "#0E2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1354 24.7408C17.6354 24.7408 17.2261 24.3362 17.2261 23.8419V21.9324C17.2261 21.438 17.6354 21.0334 18.1354 21.0334C18.6354 21.0334 19.0447 21.438 19.0447 21.9324V23.8419C19.0447 24.3362 18.6354 24.7408 18.1354 24.7408Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1353 21.2257C17.7394 21.2257 17.4183 21.5463 17.4183 21.9323V23.8418C17.4183 24.2279 17.7394 24.5485 18.1353 24.5485C18.5312 24.5485 18.8523 24.2279 18.8523 23.8418V21.9323C18.8523 21.5463 18.5312 21.2257 18.1353 21.2257ZM17.0337 21.9323C17.0337 21.3297 17.5312 20.8411 18.1353 20.8411C18.7395 20.8411 19.237 21.3297 19.237 21.9323V23.8418C19.237 24.4445 18.7395 24.9331 18.1353 24.9331C17.5312 24.9331 17.0337 24.4445 17.0337 23.8418V21.9323Z",
    fill: "#0E2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3666 24.7408C21.8666 24.7408 21.4573 24.3362 21.4573 23.8419V21.9324C21.4573 21.438 21.8666 21.0334 22.3666 21.0334C22.8666 21.0334 23.2759 21.438 23.2759 21.9324V23.8419C23.2759 24.3362 22.8666 24.7408 22.3666 24.7408Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3665 21.2257C21.9706 21.2257 21.6495 21.5463 21.6495 21.9323V23.8418C21.6495 24.2279 21.9706 24.5485 22.3665 24.5485C22.7624 24.5485 23.0835 24.2279 23.0835 23.8418V21.9323C23.0835 21.5463 22.7624 21.2257 22.3665 21.2257ZM21.2649 21.9323C21.2649 21.3297 21.7624 20.8411 22.3665 20.8411C22.9707 20.8411 23.4682 21.3297 23.4682 21.9323V23.8418C23.4682 24.4445 22.9707 24.9331 22.3665 24.9331C21.7624 24.9331 21.2649 24.4445 21.2649 23.8418V21.9323Z",
    fill: "#0E2340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.329 16.9499H13.5028C13.408 16.9499 13.3301 16.8735 13.3301 16.7797C13.3301 16.6853 13.408 16.6089 13.5028 16.6089H14.329C14.4238 16.6089 14.5011 16.6853 14.5011 16.7797C14.5011 16.8735 14.4238 16.9499 14.329 16.9499Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5341 16.9499H17.7079C17.613 16.9499 17.5352 16.8735 17.5352 16.7797C17.5352 16.6853 17.613 16.6089 17.7079 16.6089H18.5341C18.6289 16.6089 18.7068 16.6853 18.7068 16.7797C18.7068 16.8735 18.6289 16.9499 18.5341 16.9499Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.329 23.0578H13.5028C13.408 23.0578 13.3301 22.9808 13.3301 22.887C13.3301 22.7933 13.408 22.7168 13.5028 22.7168H14.329C14.4238 22.7168 14.5011 22.7933 14.5011 22.887C14.5011 22.9808 14.4238 23.0578 14.329 23.0578Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5341 23.0578H17.7079C17.613 23.0578 17.5352 22.9808 17.5352 22.887C17.5352 22.7933 17.613 22.7168 17.7079 22.7168H18.5341C18.6289 22.7168 18.7068 22.7933 18.7068 22.887C18.7068 22.9808 18.6289 23.0578 18.5341 23.0578Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7501 16.9499H21.924C21.8291 16.9499 21.7512 16.8735 21.7512 16.7797C21.7512 16.6853 21.8291 16.6089 21.924 16.6089H22.7501C22.845 16.6089 22.9229 16.6853 22.9229 16.7797C22.9229 16.8735 22.845 16.9499 22.7501 16.9499Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7501 23.0578H21.924C21.8291 23.0578 21.7512 22.9808 21.7512 22.887C21.7512 22.7933 21.8291 22.7168 21.924 22.7168H22.7501C22.845 22.7168 22.9229 22.7933 22.9229 22.887C22.9229 22.9808 22.845 23.0578 22.7501 23.0578Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0434 22.7717C10.8794 22.7717 10.7454 22.6391 10.7454 22.4777V16.7779C10.7454 16.6164 10.8794 16.4839 11.0434 16.4839C11.2068 16.4839 11.3408 16.6164 11.3408 16.7779V22.4777C11.3408 22.6391 11.2068 22.7717 11.0434 22.7717Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0786 22.7717C24.9146 22.7717 24.7805 22.6391 24.7805 22.4777V16.7779C24.7805 16.6164 24.9146 16.4839 25.0786 16.4839C25.2425 16.4839 25.376 16.6164 25.376 16.7779V22.4777C25.376 22.6391 25.2425 22.7717 25.0786 22.7717Z",
    fill: "#7EE0E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2472 19.7591H11.7372C11.6793 19.7591 11.6318 19.7122 11.6318 19.6549C11.6318 19.5976 11.6793 19.5507 11.7372 19.5507H12.2472C12.3052 19.5507 12.3526 19.5976 12.3526 19.6549C12.3526 19.7122 12.3052 19.7591 12.2472 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2631 19.7591H12.7531C12.6951 19.7591 12.6477 19.7122 12.6477 19.6549C12.6477 19.5976 12.6951 19.5507 12.7531 19.5507H13.2631C13.3211 19.5507 13.3685 19.5976 13.3685 19.6549C13.3685 19.7122 13.3211 19.7591 13.2631 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2804 19.7591H13.7704C13.7125 19.7591 13.665 19.7122 13.665 19.6549C13.665 19.5976 13.7125 19.5507 13.7704 19.5507H14.2804C14.3384 19.5507 14.3858 19.5976 14.3858 19.6549C14.3858 19.7122 14.3384 19.7591 14.2804 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2963 19.7591H14.7863C14.7283 19.7591 14.6809 19.7122 14.6809 19.6549C14.6809 19.5976 14.7283 19.5507 14.7863 19.5507H15.2963C15.3543 19.5507 15.4017 19.5976 15.4017 19.6549C15.4017 19.7122 15.3543 19.7591 15.2963 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3139 19.7591H15.8039C15.7459 19.7591 15.6985 19.7122 15.6985 19.6549C15.6985 19.5976 15.7459 19.5507 15.8039 19.5507H16.3139C16.3718 19.5507 16.4193 19.5976 16.4193 19.6549C16.4193 19.7122 16.3718 19.7591 16.3139 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3297 19.7591H16.8198C16.7618 19.7591 16.7144 19.7122 16.7144 19.6549C16.7144 19.5976 16.7618 19.5507 16.8198 19.5507H17.3297C17.3877 19.5507 17.4351 19.5976 17.4351 19.6549C17.4351 19.7122 17.3877 19.7591 17.3297 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3456 19.7591H17.8356C17.7777 19.7591 17.7302 19.7122 17.7302 19.6549C17.7302 19.5976 17.7777 19.5507 17.8356 19.5507H18.3456C18.4036 19.5507 18.451 19.5976 18.451 19.6549C18.451 19.7122 18.4036 19.7591 18.3456 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3629 19.7591H18.853C18.795 19.7591 18.7476 19.7122 18.7476 19.6549C18.7476 19.5976 18.795 19.5507 18.853 19.5507H19.3629C19.4209 19.5507 19.4683 19.5976 19.4683 19.6549C19.4683 19.7122 19.4209 19.7591 19.3629 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3774 19.7591H19.8674C19.8094 19.7591 19.762 19.7122 19.762 19.6549C19.762 19.5976 19.8094 19.5507 19.8674 19.5507H20.3774C20.4353 19.5507 20.4827 19.5976 20.4827 19.6549C20.4827 19.7122 20.4353 19.7591 20.3774 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3932 19.7591H20.8832C20.8253 19.7591 20.7778 19.7122 20.7778 19.6549C20.7778 19.5976 20.8253 19.5507 20.8832 19.5507H21.3932C21.4512 19.5507 21.4986 19.5976 21.4986 19.6549C21.4986 19.7122 21.4512 19.7591 21.3932 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4108 19.7591H21.9008C21.8428 19.7591 21.7954 19.7122 21.7954 19.6549C21.7954 19.5976 21.8428 19.5507 21.9008 19.5507H22.4108C22.4688 19.5507 22.5162 19.5976 22.5162 19.6549C22.5162 19.7122 22.4688 19.7591 22.4108 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4267 19.7591H22.9167C22.8587 19.7591 22.8113 19.7122 22.8113 19.6549C22.8113 19.5976 22.8587 19.5507 22.9167 19.5507H23.4267C23.4846 19.5507 23.5321 19.5976 23.5321 19.6549C23.5321 19.7122 23.4846 19.7591 23.4267 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.444 19.7591H23.934C23.876 19.7591 23.8286 19.7122 23.8286 19.6549C23.8286 19.5976 23.876 19.5507 23.934 19.5507H24.444C24.502 19.5507 24.5494 19.5976 24.5494 19.6549C24.5494 19.7122 24.502 19.7591 24.444 19.7591Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04639 10.4812V21.3857C1.04639 22.4803 1.944 23.3677 3.05123 23.3677H9.53478C10.6075 23.3677 11.4764 22.5081 11.4764 21.4483V10.4812",
    fill: "#DD5546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.507812 21.3857V10.4812H1.58474V21.3857C1.58474 22.1771 2.23541 22.8292 3.05112 22.8292H9.53467C10.3157 22.8292 10.9378 22.205 10.9378 21.4483V10.4812H12.0147V21.4483C12.0147 22.8112 10.899 23.9061 9.53467 23.9061H3.05112C1.65236 23.9061 0.507812 22.7835 0.507812 21.3857Z",
    fill: "#08162D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2966 10.6796H11.097C11.5285 10.6796 11.8822 10.33 11.8822 9.90285V6.27996C11.8822 5.85279 11.5285 5.50317 11.097 5.50317H1.40126C0.969137 5.50317 0.615479 5.85279 0.615479 6.27996V9.90285C0.615479 10.33 0.969137 10.6796 1.40126 10.6796H4.04081",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0769043 6.27985C0.0769043 5.54946 0.677499 4.9646 1.40114 4.9646H11.0969C11.8202 4.9646 12.4205 5.54972 12.4205 6.27985V9.90273C12.4205 10.6329 11.8202 11.218 11.0969 11.218H10.2965C9.99909 11.218 9.75802 10.9769 9.75802 10.6795C9.75802 10.3821 9.99909 10.1411 10.2965 10.1411H11.0969C11.2366 10.1411 11.3436 10.027 11.3436 9.90273V6.27985C11.3436 6.15562 11.2366 6.04152 11.0969 6.04152H1.40114C1.26055 6.04152 1.15383 6.15588 1.15383 6.27985V9.90273C1.15383 10.0267 1.26055 10.1411 1.40114 10.1411H4.0407C4.33809 10.1411 4.57916 10.3821 4.57916 10.6795C4.57916 10.9769 4.33809 11.218 4.0407 11.218H1.40114C0.677499 11.218 0.0769043 10.6331 0.0769043 9.90273V6.27985Z",
    fill: "#08162D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9946 7.13751V6.71959C10.9946 6.62119 10.9103 6.53784 10.8108 6.53784H1.63088C1.53134 6.53784 1.44702 6.62119 1.44702 6.71959V7.69434C1.44702 7.79274 1.53134 7.87551 1.63088 7.87551C1.63088 7.87551 6.96035 7.13751 10.9946 7.13751Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3536 20.281H5.58089C4.83082 20.281 4.22363 19.6801 4.22363 18.9392V12.9431C4.22363 12.3435 4.71548 11.8567 5.32208 11.8567H11.3536C11.4508 11.8567 11.5287 11.9343 11.5287 12.0303V20.1079C11.5287 20.2034 11.4508 20.281 11.3536 20.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32197 12.395C5.00726 12.395 4.76198 12.6462 4.76198 12.943V18.9391C4.76198 19.377 5.12239 19.7424 5.58077 19.7424H10.9901V12.395H5.32197ZM3.68506 12.943C3.68506 12.0405 4.42346 11.3181 5.32197 11.3181H11.3535C11.7446 11.3181 12.067 11.6333 12.067 12.0302V20.1078C12.067 20.5053 11.7434 20.8193 11.3535 20.8193H5.58077C4.53903 20.8193 3.68506 19.9831 3.68506 18.9391V12.943Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23071 13.9999H10.6153V13.2307H5.23071V13.9999Z",
    fill: "#0392C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37205 16.1199H5.83894V15.2267H6.36591C6.66828 15.2267 6.85707 15.4017 6.85707 15.6733C6.85707 15.951 6.678 16.1199 6.37205 16.1199ZM8.12138 16.7486H7.83385C7.77604 16.7486 7.72232 16.7795 7.69469 16.8285L7.41893 17.3252L7.01884 16.5792C6.98405 16.5145 7.01014 16.4376 7.0746 16.4007C7.334 16.2515 7.48083 15.9748 7.48083 15.6617C7.48083 15.1084 7.09814 14.769 6.42996 14.769H5.36987C5.29262 14.769 5.23071 14.8292 5.23071 14.9036V17.4355C5.23071 17.5098 5.29262 17.5695 5.36987 17.5695H5.69885C5.77559 17.5695 5.83852 17.5098 5.83852 17.4355V16.6793C5.83852 16.605 5.90094 16.5448 5.97768 16.5448H6.24987C6.30256 16.5448 6.35014 16.5731 6.37419 16.6181L6.97995 17.7683L6.32968 18.755C6.26317 18.8567 6.33838 18.9892 6.4627 18.9892H6.73233C6.78963 18.9892 6.84284 18.9588 6.87047 18.9103L7.23986 18.2609L7.56832 18.8845C7.59185 18.9295 7.63995 18.9578 7.69264 18.9578H8.06664C8.17101 18.9578 8.23803 18.8511 8.19045 18.7616L7.69316 17.8355L8.25492 16.9823C8.32143 16.8806 8.24622 16.7486 8.12138 16.7486Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8755 9.68796L23.7834 14.5397C24.178 14.9298 24.8174 14.9298 25.2127 14.5397L27.7415 12.0397C28.1456 11.6404 28.1456 10.9921 27.7415 10.5927L22.8506 5.7583",
    fill: "#7EE0E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3245 2.47607L28.1556 10.2176C28.7728 10.8278 28.7728 11.8198 28.1556 12.43L25.6261 14.9305C25.0215 15.5281 24.0448 15.5277 23.44 14.9308L15.5828 7.16282L20.3245 2.47607ZM16.6363 6.40324L24.1965 14.1643C24.3822 14.3476 24.6843 14.3472 24.869 14.1646L27.3985 11.6641C27.5893 11.4755 27.5893 11.1721 27.3985 10.9835L19.846 3.23066L16.6363 6.40324Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6053 11.6763L28.7077 12.7661C29.2116 13.2635 29.2118 14.0737 28.7079 14.571L27.8702 15.3991C27.3798 15.8839 26.5876 15.8834 26.0971 15.3995L24.968 14.2834L27.6053 11.6763ZM26.0971 13.8818L26.8534 14.6328C26.925 14.7033 27.0427 14.7028 27.1131 14.6332L27.951 13.8049C28.0277 13.7293 28.0281 13.6084 27.9514 13.5328L27.2025 12.789L26.0971 13.8818Z",
    fill: "#08162D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8899 8.13323L21.3049 1.79102L14.8899 8.13323Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6877 1.41233C21.8968 1.62381 21.8949 1.96474 21.6834 2.17382L15.2684 8.51604C15.0569 8.72512 14.7159 8.72317 14.5069 8.51169C14.2978 8.30021 14.2997 7.95928 14.5112 7.7502L20.9262 1.40799C21.1377 1.19891 21.4787 1.20085 21.6877 1.41233Z",
    fill: "#08162D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8613 3.90174L16.8745 0.923096L13.8613 3.90174Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2573 0.54443C17.4663 0.755919 17.4644 1.09685 17.2529 1.30592L14.2398 4.28457C14.0283 4.49364 13.6874 4.49167 13.4783 4.28018C13.2692 4.0687 13.2712 3.72777 13.4827 3.5187L16.4958 0.540049C16.7073 0.33098 17.0482 0.332942 17.2573 0.54443Z",
    fill: "#08162D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4741 14.2563C27.6832 14.0449 28.0241 14.0429 28.2356 14.252L31.7628 17.7388C31.9743 17.9479 31.9763 18.2888 31.7672 18.5003C31.5581 18.7118 31.2172 18.7138 31.0057 18.5047L27.4785 15.0178C27.267 14.8088 27.2651 14.4678 27.4741 14.2563Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3042 8.42822C26.5133 8.63971 26.5113 8.98064 26.2998 9.18971L24.949 10.5251C24.7375 10.7341 24.3966 10.7322 24.1875 10.5207C23.9784 10.3092 23.9804 9.96826 24.1919 9.75919L25.5427 8.42384C25.7542 8.21477 26.0951 8.21673 26.3042 8.42822Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0964 7.23608C25.3055 7.44757 25.3035 7.7885 25.092 7.99757L23.7412 9.33292C23.5297 9.54199 23.1888 9.54003 22.9797 9.32854C22.7707 9.11705 22.7726 8.77612 22.9841 8.56706L24.3349 7.2317C24.5464 7.02263 24.8874 7.02459 25.0964 7.23608Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8901 6.0437C24.0992 6.25519 24.0972 6.59612 23.8857 6.80519L22.5349 8.14054C22.3234 8.34961 21.9825 8.34765 21.7734 8.13616C21.5644 7.92467 21.5663 7.58374 21.7778 7.37467L23.1286 6.03932C23.3401 5.83025 23.6811 5.83221 23.8901 6.0437Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6838 4.85131C22.8929 5.0628 22.8909 5.40373 22.6794 5.6128L21.3286 6.94816C21.1171 7.15723 20.7762 7.15527 20.5671 6.94378C20.3581 6.73229 20.36 6.39136 20.5715 6.18229L21.9223 4.84693C22.1338 4.63786 22.4748 4.63983 22.6838 4.85131Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2193 1.66943L14.6536 3.21722L17.2369 5.77101L18.8026 4.22322L16.2193 1.66943Z",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2193 1.66943L14.6536 3.21722L17.2369 5.77101L18.8026 4.22322L16.2193 1.66943Z",
    stroke: "#08162D",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    d: "M24.2713 13.2621L21.8425 10.8611",
    stroke: "#F5F6F6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    d: "M20.8134 9.84166L20.3713 9.40465",
    stroke: "#F5F6F6",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugsIcon);
export default __webpack_public_path__ + "static/media/drugs_icon.e2319e2e6b93607e2435db9d20e5b779.svg";
export { ForwardRef as ReactComponent };